import React from "react";
import { useOperatorUsers } from "./OperatorUsersContext";
import {
  CircularProgress,
  Box,
  Typography,
  TableCell,
  Button,
} from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { OperatorUserModel } from "./utils";

const OperatorUsersList = () => {
  const {
    operatorUsers,
    setSelectedOperatorUser,
    setOperatorUser,
    authenticationChecked,
  } = useOperatorUsers();
  const [error, setError] = React.useState("");

  const viewEditLinkIcon = (item) => {
    return (
      <Link
        className="hyper-links"
        onClick={(e) => setSelectedOperatorUser(item)}
      >
        {item.id}
      </Link>
    );
  };

  const disproles = (operAcc) => {
    return operAcc.roles.map((eachrole, idx) => {
      return eachrole;
    });
  };

  const convertDateISOToUTC = (isoDate) => {
    if (isoDate !== null && isoDate !== "") {
      const date = new Date(isoDate);
      const utcFormatted = `${date.getUTCFullYear()}-${String(
        date.getUTCMonth() + 1,
      ).padStart(2, "0")}-${String(date.getUTCDate()).padStart(
        2,
        "0",
      )} ${String(date.getUTCHours()).padStart(2, "0")}:${String(
        date.getUTCMinutes(),
      ).padStart(2, "0")}:${String(date.getUTCSeconds()).padStart(2, "0")}`;
      return utcFormatted;
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
        <div style={{ flex: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const dataGridColumns = [
    {
      field: "id",
      headerName: "Id",
      filterable: true,
      sortable: true,
      renderCell: (params) => viewEditLinkIcon(params.row),
    },
    {
      field: "login",
      headerName: "Login",
      filterable: true,
      sortable: true,
      width: 150,
    },
    {
      field: "name",
      headerName: "Name",
      filterable: true,
      sortable: true,
      width: 200,
    },
    {
      field: "organization",
      headerName: "Organization",
      filterable: true,
      sortable: true,
      width: 200,
    },
    {
      field: "email",
      headerName: "Email",
      filterable: true,
      sortable: true,
      width: 250,
    },
    {
      field: "agencyName",
      headerName: "Agency",
      filterable: true,
      sortable: true,
    },
    {
      field: "roles",
      headerName: "Roles",
      filterable: true,
      sortable: true,
      renderCell: (params) => disproles(params.row),
    },
    {
      field: "approved",
      headerName: "Approved",
      filterable: true,
      sortable: true,
      width: 200,
      renderCell: (params) => convertDateISOToUTC(params.row.approved),
    },
    {
      field: "updated",
      headerName: "Updated",
      filterable: true,
      sortable: true,
      width: 200,
      renderCell: (params) => convertDateISOToUTC(params.row.updated),
    },
  ];

  if (operatorUsers !== null && operatorUsers.length > 0) {
    return (
      <>
        <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}>
          {" "}
          Manage Operator User Accounts{" "}
        </Typography>
        <TableCell>
          <Button
            variant="contained"
            onClick={(e) =>
              setOperatorUser({ ...OperatorUserModel, roles: [] })
            }
          >
            {" "}
            Create New Operator User{" "}
          </Button>
        </TableCell>
        <DataGrid
          rows={operatorUsers}
          columns={dataGridColumns}
          disableSelectionOnClick
          components={{
            Toolbar: CustomToolbar,
          }}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              fontSize: "1rem",
              fontWeight: "bold",
              display: "flex",
            },
          }}
        />
      </>
    );
  } else {
    if (authenticationChecked === "Success") {
      return (
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <CircularProgress />
        </Box>
      );
    }
    if (authenticationChecked === "UNAUTHORIZED") {
      const wasAdminLoggedIn = sessionStorage.getItem("isAdmin") === "true";
      const isUserLoggedIn = sessionStorage.getItem("isUser") === "true";
      if (isUserLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            You are not authorized to view this page.
          </Typography>
        );
      else if (wasAdminLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            Session expired.{" "}
            <a
              href={process.env.PUBLIC_URL + "/About/AdminLogin"}
              className="hyper-links"
            >
              <b>Click here to log back in</b>
            </a>
          </Typography>
        );
      else return <Navigate to="/About/AdminLogin" replace />;
    }
    if (authenticationChecked === "FORBIDDEN")
      return <Navigate to="/About/AdminLogin" replace />;
  }
};

export default OperatorUsersList;
